import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import Directories from "../components/Home/Directories";
import FormHome from "../components/Home/FormHome";
import Map from "../components/Contact/MapContent";
import Modal from "../components/Home/Modal";
import BaseLayout from "../components/global/BaseLayout";
import CounterUp from "../components/global/CounterUp";
import ServicesHome from "../components/Services/ServicesHome_3";
import HeroSection from "../components/Home/HeroVideo";
import Paletacolor from "../components/global/Paletacolor";
import BlockFour from "../components/block/BlockFour";
import BlockTwo from "../components/block/BlockTwo";
import BlockOne from "../components/block/BlockOne";
import VideoPromocional from "../components/global/VideoPromcional";

// para agregar la frase de los años de experiencia o la licencia agregar sloganPrincipal={true}
// para agregar la lista de about agregar listsAbout={true}
// para agregar la lista de servicios agregar listsServices={true}

function Home() {
  const { rpdata } = useContext(GlobalDataContext);

  return (
    <BaseLayout PageName="Home">
      <div className="md:max-w-full w-full">
        <Modal />
        <HeroSection 
        urlVideo={"https://firebasestorage.googleapis.com/v0/b/videospromo-24754.appspot.com/o/General%20Air%20Technology%20Inc.mp4?alt=media&token=6d88a783-1614-4570-adf3-feb19b4fc058"}
        />
        <BlockFour
          text={rpdata?.dbHome?.[0]?.text}
          image1={rpdata?.stock?.[8]}
          image2={rpdata?.stock?.[7]}
          image3={rpdata?.stock?.[1]}
          sloganPrincipal={true}
          listsServices={true}
        />

        <Directories />

        {/* video promocional */}
        {
          rpdata?.videosPromo?.[0]?.activo ?
            <VideoPromocional
              title={rpdata?.dbSlogan?.[2]?.slogan}
              text={rpdata?.dbAbout?.[1]?.text}
              linkVideo={`${rpdata?.videosPromo?.[0].link}`}
              image={`${rpdata?.videosPromo?.[0].img}`}

            />
            : null

        }

        <BlockOne
          text={rpdata?.dbHome?.[1].text}
          title={rpdata?.dbSlogan?.[3]?.slogan}
          image={rpdata?.stock?.[5]}
        />

        <CounterUp image={rpdata?.stock?.[6]} />

        <BlockTwo
          title={'a little about us'}
          text={rpdata?.dbAbout?.[0]?.text}
          image={rpdata?.stock?.[2]}
          listsAbout={true}
        />
        <ServicesHome />
        {/* Paleta de Colores */}
        {
          rpdata?.brandingExtra?.[0]?.activo ?
            <Paletacolor />
            : null
        }
        <div
          className="bgFormHome"
          style={{ backgroundImage: `url("${rpdata?.stock?.[5]}")` }}
        >
          <div className="relative">
            <FormHome />
          </div>
        </div>
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Home;
